<template>
    <div>
        <div class="d-lg-flex me-0 mb-1 mb-lg-0 d-lg-flex align-items-center">
            <div class="d-flex align-items-center">
                <span class="ob1-capsule ob1-capsule-information pe-1 fw-normal" v-html="title" />
                <!--Affichage en mode tablette et desktop-->
                <div class="d-none d-md-block">
                    <span class="fw-normal" v-html="text" />
                </div>
                <!--Affichage en mode mobile-->
                <div class="row px-1 d-md-none">
                    <div class="col-12 px-0 fw-normal" v-html="text" />
                </div>
            </div>
            <div class="d-flex mt-1 mt-lg-0 ms-lg-1 align-items-center">
                <!--/* Modifier mon choix */-->
                <div class="d-flex align-items-center">
                    <span class="icon icon-reload">&nbsp;</span>
                    <ob1-liens
                        class="d-flex fw-bold py-0"
                        :is-button="modifyButton.isButton"
                        :text="modifyButton.text"
                        :href="modifyButton.href"
                        is-mini
                        no-decoration
                    />
                </div>
                <!--/* Supprimer */-->
                <div v-if="deleteButton" class="ms-1 d-flex align-items-center">
                    <span class="icon icon-trash">&nbsp;</span>
                    <ob1-liens
                        class="d-flex fw-bold py-0"
                        :is-button="deleteButton.isButton"
                        :text="deleteButton.text"
                        :href="deleteButton.href"
                        is-mini
                        no-decoration
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SelectedDevice",
    props: {
        title: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: true
        },
        modifyButton: {
            type: Object,
            required: true,
        },
        deleteButton: {
            type: Object,
            required: false,
            default: null
        }
    }
}
</script>
